const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "8px",
    viewBox: "0 0 16 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillrule: "evenodd",
      fill: "rgb(6.27451%,63.921569%,49.803922%)",
      fillOpacity: 1
    },
    d: "M 0.605469 0 L 14.289062 0 C 14.515625 0 14.695312 0.183594 14.695312 0.40625 L 14.695312 1.914062 C 14.707031 1.910156 14.71875 1.90625 14.734375 1.90625 L 15.78125 1.90625 C 15.894531 1.90625 15.984375 2 15.984375 2.109375 L 15.984375 5.769531 C 15.984375 5.882812 15.894531 5.972656 15.78125 5.972656 L 14.734375 5.972656 C 14.71875 5.972656 14.707031 5.972656 14.695312 5.96875 L 14.695312 7.640625 C 14.695312 7.867188 14.515625 8.046875 14.289062 8.046875 L 0.402344 8.046875 C 0.179688 8.046875 0 7.867188 0 7.640625 L 0 0.609375 C 0 0.273438 0.273438 0 0.605469 0 Z M 2.199219 1.945312 L 12.492188 1.945312 L 12.492188 6.101562 L 2.199219 6.101562 Z M 1.382812 1.109375 L 13.3125 1.109375 L 13.3125 6.9375 L 1.382812 6.9375 Z M 1.382812 1.109375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.24d954db2a3810c8799e2965d0a90de4.svg";
export { ForwardRef as ReactComponent };